{
  "pages": {
    "listTitle": "Hoa hồng nhân viên",
    "periodTitle": "Kỳ hoa hồng",
    "rulesTitle": "Quy tắc hoa hồng",
    "addTitle": "Thêm quy tắc hoa hồng",
    "editTitle": "Sửa quy tắc hoa hồng",
    "viewTitle": "Quy tắc hoa hồng",
    "permissionDenied": "Bạn không có quyền xem hoa hồng.",
    "createPermissionDenied": "Bạn không có quyền tạo quy tắc hoa hồng.",
    "editPermissionDenied": "Bạn không có quyền sửa quy tắc hoa hồng.",
    "tabs": {
      "period": "Kỳ hoa hồng",
      "sheets": "Phiếu hoa hồng",
      "rules": "Quy tắc hoa hồng"
    },
    "tabsAria": "Phần module hoa hồng",
    "sheetDetailTitle": "Chi tiết phiếu hoa hồng"
  },
  "status": {
    "draft": "Nháp",
    "active": "Đang áp dụng",
    "inactive": "Đã tắt",
    "accrued": "Tạm tính",
    "locked": "Đã chốt",
    "paid": "Đã chi",
    "void": "Hủy"
  },
  "sourceTypes": {
    "payment": "Thanh toán",
    "lab_true_up": "Điều chỉnh lab",
    "quantity": "Số lượng hoàn thành",
    "chart": "Lượt hồ sơ",
    "plan_item": "Doanh số hạng mục"
  },
  "basisTypes": {
    "collected": "Tiền đã thu",
    "collected_minus_lab": "Tiền thu trừ chi phí lab",
    "collected_minus_lab_minus_inventory": "Tiền thu trừ lab và vật tư điều trị",
    "per_chart": "Lượt hồ sơ giới thiệu",
    "contracted_payable": "Doanh số phải thu"
  },
  "basisTypeHints": {
    "collected": "Công thức nhân trên số BN đã trả cho hạng mục. Không trừ lab.",
    "collected_minus_lab": "Trừ giá tạm lab lúc thu; khi hóa đơn lệch thì điều chỉnh kỳ đang mở.",
    "collected_minus_lab_minus_inventory": "Trừ lab (nếu có) rồi trừ giá vốn vật tư đã xuất điều trị (có cờ trừ HH lúc ghi sổ).",
    "per_chart": "Một dòng khi tạo hồ sơ có người giới thiệu là nhân viên. Không lọc dịch vụ.",
    "contracted_payable": "Doanh số phải thu khi hạng mục vào nhóm đã ký, nếu người giới thiệu là nhân viên."
  },
  "roles": {
    "primary": "Bác sĩ chính",
    "assistant": "Phụ tá",
    "inner_assistant": "Phụ tá vòng trong",
    "outer_assistant": "Phụ tá vòng ngoài",
    "consultant": "Bác sĩ tư vấn (trên kế hoạch)",
    "consulting_staff": "Nhân viên tư vấn",
    "representative": "Bác sĩ đại diện (trên kế hoạch)",
    "responsible": "Bác sĩ phụ trách (trên dòng dịch vụ)",
    "treating": "Bác sĩ điều trị (trên phiên điều trị)",
    "specific_staff": "Nhân viên cụ thể",
    "referrer": "Người giới thiệu"
  },
  "formula": {
    "percent": "Phần trăm",
    "fixed": "Số cố định",
    "tiered": "Bậc thang",
    "per_unit": "Theo số lượng",
    "perUnitShort": "đơn vị"
  },
  "fields": {
    "name": "Tên quy tắc",
    "description": "Mô tả",
    "status": "Trạng thái",
    "priority": "Độ ưu tiên",
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "catalogIds": "Dịch vụ áp dụng",
    "categoryIds": "Nhóm dịch vụ",
    "staffIds": "Nhân viên đủ điều kiện",
    "departments": "Phòng ban",
    "employeeTypes": "Loại nhân viên",
    "role": "Vai trò nhận",
    "source": "Nguồn",
    "basisType": "Cơ sở tính",
    "formulaType": "Công thức",
    "percent": "Phần trăm (%)",
    "fixedAmount": "Số tiền cố định",
    "unitPrice": "Đơn giá / đơn vị",
    "quantityBasis": "{{count}} đơn vị",
    "specificStaff": "Chọn nhân viên",
    "tiers": "Bậc thang",
    "tierMin": "Từ",
    "tierMax": "Đến",
    "tierRate": "Tỷ lệ %",
    "period": "Kỳ",
    "beneficiary": "Người nhận",
    "basis": "Cơ sở tính",
    "commission": "Hoa hồng",
    "rule": "Quy tắc",
    "entryCount": "Số dòng",
    "expense": "Phiếu chi",
    "patient": "Bệnh nhân",
    "treatmentPlan": "Kế hoạch điều trị",
    "payment": "Thanh toán",
    "clinic": "Phòng khám",
    "allClinics": "Tất cả phòng khám"
  },
  "hints": {
    "emptyPeriod": "Kỳ này chưa có dòng hoa hồng. Kiểm tra quy tắc đang áp dụng, thanh toán có phân bổ dịch vụ, và đã gắn bác sĩ trên kế hoạch/phiên điều trị.",
    "clinicRequired": "Chọn một phòng khám để chốt hoa hồng.",
    "lockDisabled": "Không có dòng tạm tính để chốt trong kỳ/phòng khám đang chọn."
  },
  "sections": {
    "conditions": "Điều kiện áp dụng",
    "basis": "Cơ sở tính hoa hồng",
    "beneficiaries": "Người nhận hoa hồng",
    "periodActions": "Chốt kỳ",
    "byStaff": "Theo nhân viên"
  },
  "table": {
    "name": "Tên",
    "status": "Trạng thái",
    "beneficiaries": "Người nhận",
    "basis": "Cơ sở",
    "period": "Hiệu lực",
    "priority": "Ưu tiên",
    "slipCode": "Mã phiếu",
    "staff": "Nhân viên",
    "totalCommission": "Tổng hoa hồng",
    "totalBasis": "Tổng cơ sở",
    "entries": "Chi tiết",
    "accrued": "Tạm tính",
    "locked": "Đã chốt",
    "paid": "Đã chi",
    "consumed": "Đã gộp lương",
    "dates": "Khoảng ngày",
    "lockedAt": "Ngày chốt",
    "lockedBy": "Người chốt",
    "createdAt": "Ngày tạo",
    "createdBy": "Người tạo",
    "updatedAt": "Ngày chỉnh sửa",
    "editedBy": "Người chỉnh sửa",
    "description": "Mô tả",
    "clinics": "Phòng khám",
    "catalogs": "Dịch vụ",
    "categories": "Nhóm dịch vụ",
    "departments": "Phòng ban",
    "employeeTypes": "Loại nhân viên",
    "eligibleStaff": "Nhân viên đủ điều kiện",
    "all": "Tất cả"
  },
  "period": {
    "accruedLabel": "Tạm tính",
    "lockedLabel": "Đã chốt",
    "paidLabel": "Đã chi"
  },
  "periodStatus": {
    "locked": "Kỳ đã chốt",
    "closed": "Kỳ đã đóng theo tháng. Mở lại nếu cần ghi phiếu thu của tháng này."
  },
  "periodChip": {
    "open": "Đang mở",
    "locked": "Đã chốt",
    "closed": "Đã đóng"
  },
  "actions": {
    "add": "Thêm quy tắc",
    "addBeneficiary": "Thêm người nhận",
    "addTier": "Thêm bậc",
    "deactivate": "Tắt quy tắc",
    "lockPeriod": "Chốt kỳ",
    "unlockPeriod": "Mở khóa kỳ",
    "reopenPeriod": "Mở lại kỳ",
    "locking": "Đang chốt…",
    "unlocking": "Đang mở khóa…",
    "reopening": "Đang mở lại…",
    "periodActions": "Thao tác kỳ",
    "openSheets": "Xem phiếu",
    "openPayment": "Xem thu",
    "openExpense": "Xem chi",
    "edit": "Sửa",
    "history": "Lịch sử"
  },
  "history": {
    "ruleTitle": "Lịch sử quy tắc hoa hồng",
    "ruleEmpty": "Chưa có lịch sử cho quy tắc này."
  },
  "filters": {
    "trigger": "Bộ lọc",
    "title": "Bộ lọc",
    "apply": "Áp dụng",
    "clearAll": "Xóa bộ lọc",
    "selectPeriod": "Chọn kỳ",
    "selectStatus": "Chọn trạng thái",
    "allStatuses": "Tất cả trạng thái"
  },
  "placeholders": {
    "search": "Tìm quy tắc…",
    "period": "VD: 2026-08",
    "name": "Ví dụ: Hoa hồng bác sĩ chính",
    "description": "Ví dụ: Hoa hồng bác sĩ chính theo dịch vụ implant",
    "clinics": "Chọn phòng khám",
    "catalogs": "Chọn dịch vụ",
    "categories": "Chọn nhóm dịch vụ",
    "staff": "Chọn nhân viên",
    "departments": "Chọn phòng ban",
    "employeeTypes": "Chọn loại nhân viên",
    "unitPrice": "Ví dụ: 200000"
  },
  "emptyList": "Chưa có quy tắc hoa hồng.",
  "emptySearch": "Không tìm thấy quy tắc phù hợp.",
  "emptyEntries": "Chưa có dòng hoa hồng trong kỳ này.",
  "emptyStaffEntries": "Chưa có dòng hoa hồng.",
  "emptySummary": "Chưa có dữ liệu tổng hợp.",
  "emptyPeriods": "Chưa có kỳ hoa hồng. Kỳ được tạo khi có dòng tạm tính hoặc khi chốt kỳ.",
  "validation": {
    "nameRequired": "Vui lòng nhập tên quy tắc",
    "startDateRequired": "Vui lòng chọn ngày bắt đầu",
    "priorityInvalid": "Độ ưu tiên phải là số",
    "beneficiaryRequired": "Cần ít nhất một người nhận",
    "legacyPrimaryRole": "Người nhận #{{index}}: vai trò Bác sĩ chính không còn dùng. Chọn bác sĩ đại diện, bác sĩ tư vấn, bác sĩ phụ trách hoặc bác sĩ điều trị.",
    "specificStaffRequired": "Người nhận #{{index}}: chọn nhân viên cụ thể",
    "formulaValueInvalid": "Người nhận #{{index}}: giá trị công thức không hợp lệ",
    "unitPriceInvalid": "Người nhận #{{index}}: đơn giá phải lớn hơn 0",
    "percentTooHigh": "Người nhận #{{index}}: phần trăm không được vượt 100",
    "tiersRequired": "Người nhận #{{index}}: cần ít nhất một bậc thang",
    "periodInvalid": "Kỳ phải có dạng YYYY-MM",
    "referrerRuleMixed": "Quy tắc người giới thiệu không gắn thêm vai trò điều trị.",
    "referrerBasisInvalid": "Người giới thiệu chỉ dùng gốc lượt hồ sơ, tiền đã thu hoặc doanh số phải thu.",
    "referrerFormulaInvalid": "Người nhận #{{index}}: người giới thiệu chỉ dùng phần trăm hoặc số cố định"
  },
  "toasts": {
    "createSuccess": "Đã tạo quy tắc hoa hồng",
    "updateSuccess": "Đã cập nhật quy tắc hoa hồng",
    "deactivateSuccess": "Đã tắt quy tắc hoa hồng",
    "saveFailed": "Không lưu được quy tắc hoa hồng",
    "deactivateFailed": "Không tắt được quy tắc",
    "loadFailed": "Không tải được danh sách quy tắc hoa hồng",
    "loadPeriodFailed": "Không tải được bảng hoa hồng theo kỳ",
    "loadPeriodsFailed": "Không tải được danh sách kỳ hoa hồng",
    "loadStaffEntriesFailed": "Không tải được hoa hồng của nhân viên",
    "loadDetailFailed": "Không tải được quy tắc hoa hồng",
    "lockSuccess": "Đã chốt {{count}} dòng hoa hồng",
    "lockSealed": "Đã khóa kỳ {{period}}",
    "unlockSuccess": "Đã mở khóa {{count}} dòng hoa hồng",
    "reopenSuccess": "Đã mở lại kỳ {{period}}",
    "lockEmpty": "Không có dòng tạm tính để chốt trong kỳ này.",
    "unlockEmpty": "Không có dòng đã chốt để mở khóa trong kỳ này.",
    "periodActionFailed": "Thao tác kỳ thất bại"
  },
  "confirmDeactivate": "Tắt quy tắc \"{{name}}\"? Các thanh toán mới sẽ không còn áp dụng quy tắc này.",
  "confirmLock": "Chốt {{count}} dòng tạm tính của kỳ {{period}}? Các thanh toán liên quan sẽ không sửa/xóa được cho đến khi mở khóa.",
  "confirmLockEmpty": "Khóa kỳ {{period}} dù chưa có dòng tạm tính? Tháng này sẽ không nhận thêm hoa hồng cho đến khi mở khóa.",
  "confirmReopen": "Mở lại kỳ {{period}} để ghi hoa hồng của tháng này?",
  "confirmUnlock": "Mở khóa {{count}} dòng đã chốt của kỳ {{period}}? Chỉ các dòng chưa chi sẽ về tạm tính.",
  "errors": {
    "COMMISSION_ALREADY_CONSUMED": "Hoa hồng đã gộp vào bảng lương, không mở khóa được.",
    "COMMISSION_ALREADY_PAID": "Hoa hồng vừa được chi hoặc đã gộp vào kỳ khác."
  }
}
